import React from 'react';

const LOGO = process.env.PUBLIC_URL + '/images/company-logo.png';

function Footer() {
  return (
    <footer id="contact" className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src={LOGO} alt="Emerald Horizon" className="footer-logo" />
          <div className="footer-content">
            <h2 className="footer-title"><span className="footer-title-gold">Emerald Horizon</span> — Bespoke Design & Renovation</h2>
            <p className="footer-intro">Unlock the potential of your property with our premium architectural finishes.</p>
            <div className="footer-section">
              <h3 className="footer-section-title">Build on Bespoke:</h3>
              <ul className="footer-list">
                <li><strong>Luxury Resin:</strong> Seamless flooring and countertops with bespoke marble effects.</li>
                <li><strong>Wall Artistry:</strong> Venetian and polished plaster for texture and depth.</li>
                <li><strong>Media Walls:</strong> Custom-built entertainment units that serve as the focal point of your room.</li>
                <li><strong>Landscaping:</strong> Complete garden transformations.</li>
                <li><strong>Resin Bound:</strong> Durable, permeable, and stylish driveways and pathways.</li>
                <li><strong>Total Transformation:</strong> Cohesive indoor-outdoor flow.</li>
              </ul>
            </div>
      
          </div>
        </div>
        <div className="footer-contact">
          <h3 className="footer-heading">Get in touch</h3>
          <p>Ready to transform your space? Contact us for a consultation.</p>
          <a href="mailto:info@emeraldhorizon.co.uk" className="footer-email">info@emeraldhorizon.co.uk</a>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Emerald Horizon. All rights reserved. UK Registered Company No: 16779365</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
